'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var React = require('react');
var TabItemHead = require('../TabItemHead/TabItemHead.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Tab = React.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      commonStyle,
      tabs = [],
      activeColor,
      textColor,
      type,
      alignment = "left"
    } = _b, rest = __objRest(_b, [
      "children",
      "commonStyle",
      "tabs",
      "activeColor",
      "textColor",
      "type",
      "alignment"
    ]);
    const numberOfChildren = tabs.length;
    const [activeTab, setActiveTab] = React.useState(0);
    const tabHeadRef = React.useRef();
    const tabHead = tabHeadRef == null ? void 0 : tabHeadRef.current;
    React.useEffect(() => {
      if (tabHead && tabHead.scroll) {
        const activeDom = tabHead.childNodes[activeTab];
        tabHead.scroll({
          left: activeDom.offsetLeft - (tabHead.offsetWidth - activeDom.offsetWidth) / 2,
          behavior: "smooth"
        });
      }
    }, [activeTab]);
    React.useEffect(() => {
      if (tabs.length - 1 < activeTab) {
        setActiveTab(Math.max(tabs.length - 1, 0));
      }
    }, [tabs]);
    return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, __spreadProps(__spreadValues({
      ref,
      commonStyle
    }, rest), {
      children: [
        !!tabs.length && /* @__PURE__ */ jsxRuntime.jsx(TabHeadWrapper, {
          ref: tabHeadRef,
          children: tabs.map((tab, index) => /* @__PURE__ */ jsxRuntime.jsx(TabItemHeadWrapper, {
            alignment,
            index,
            arrayLength: numberOfChildren,
            children: /* @__PURE__ */ jsxRuntime.jsx(TabItemHead.TabItemHead, __spreadProps(__spreadValues({
              id: `tab-${index}`,
              activeColor,
              textColor,
              isActive: index === activeTab,
              alignment,
              onClick: () => {
                setActiveTab(index);
              },
              type
            }, tab), {
              children: /* @__PURE__ */ jsxRuntime.jsx("span", {
                dangerouslySetInnerHTML: { __html: tab.title }
              })
            }))
          }, index))
        }),
        (children == null ? void 0 : children[activeTab]) || (children != null ? children : null)
      ]
    }));
  }
);
const TabHeadWrapper = styled__default["default"].div`
  display: flex;
  white-space: nowrap;
  overflow-x: scroll;
  gap: 8px;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    width: 100%;
    position: relative;
    ${coreRenderer.getStyle(commonStyle)};
`
);
const getItemHeadAlignment = (alignment, index, arrayLength) => {
  switch (alignment) {
    case "center":
      if (index === 0)
        return "margin-left: auto;";
      else if (index === arrayLength - 1)
        return "margin-right: auto;";
      else
        return "";
    case "justify":
      return "margin: auto;";
    case "right":
      if (index === 0)
        return "margin-left: auto;";
      else
        return "";
    case "left":
      if (index === arrayLength - 1)
        return "margin-right: auto";
      else
        return "";
    default:
      return "";
  }
};
const TabItemHeadWrapper = styled__default["default"].div(
  ({
    alignment,
    index,
    arrayLength
  }) => `
  ${getItemHeadAlignment(alignment, index, arrayLength)}`
);
Tab.displayName = "Tab";

exports.Tab = Tab;
exports.TabHeadWrapper = TabHeadWrapper;
